import { jsonFetch } from './../utils/fetch';
import { urls } from './../config';

const getSubjTest = () => jsonFetch(urls.subjTest);
const nextStep = data => jsonFetch(`${urls.subjTest}`, data, { method: 'POST' });

export default {
  getSubjTest,
  nextStep,
};



// WEBPACK FOOTER //
// ./src/api/subjTest.js